var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJuridiqueIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.629,
    height: 47.704,
    viewBox: "0 0 40.629 47.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_195",
    x: 13.752,
    y: 9.076,
    width: 10.375,
    height: 35.878,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.529
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_196",
    x: 6.876,
    y: 22.828,
    width: 10.391,
    height: 13.875,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.529
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_197",
    x: 16.502,
    y: 11.068,
    width: 10.375,
    height: 33.886,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.529
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_198",
    x: 16.502,
    y: 9.076,
    width: 10.375,
    height: 13.891,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.529
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_199",
    x: 0,
    y: 33.829,
    width: 10.391,
    height: 13.875,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.529
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_200",
    x: 30.237,
    y: 33.829,
    width: 10.391,
    height: 13.875,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.529
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_201",
    x: 1.992,
    y: 0,
    width: 36.645,
    height: 47.704,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.529
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3986745-building-company-skyscraper-skyscraper-icon_112331",
    "data-name": "3986745-building-company-skyscraper-skyscraper-icon_112331",
    transform: "translate(-21.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_127",
    "data-name": "Groupe 127",
    transform: "translate(26.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_126",
    "data-name": "Groupe 126"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, 0)",
    filter: "url(#Trac\\xE9_195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_195-2",
    "data-name": "Trac\\xE9 195",
    d: "M226.689,132a.688.688,0,0,0-.688.688v22a.688.688,0,1,0,1.375,0v-22A.688.688,0,0,0,226.689,132Z",
    transform: "translate(-207.75 -122.92)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, 0)",
    filter: "url(#Trac\\xE9_196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_196-2",
    "data-name": "Trac\\xE9 196",
    d: "M126.689,333.374h.016a.688.688,0,0,0,0-1.375h-.016a.688.688,0,0,0,0,1.375Z",
    transform: "translate(-114.63 -309.17)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, 0)",
    filter: "url(#Trac\\xE9_197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_197-2",
    "data-name": "Trac\\xE9 197",
    d: "M267.374,161.654a.688.688,0,0,0-1.375,0v20.011a.688.688,0,0,0,1.375,0V161.654Z",
    transform: "translate(-245 -149.9)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, 0)",
    filter: "url(#Trac\\xE9_198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_198-2",
    "data-name": "Trac\\xE9 198",
    d: "M266.687,133.39a.688.688,0,0,0,.688-.688v-.016a.688.688,0,1,0-1.375,0v.016A.688.688,0,0,0,266.687,133.39Z",
    transform: "translate(-245 -122.92)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, 0)",
    filter: "url(#Trac\\xE9_199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_199-2",
    "data-name": "Trac\\xE9 199",
    d: "M26.7,492h-.016a.688.688,0,0,0,0,1.375H26.7a.688.688,0,0,0,0-1.375Z",
    transform: "translate(-21.5 -458.17)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, 0)",
    filter: "url(#Trac\\xE9_200)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_200-2",
    "data-name": "Trac\\xE9 200",
    d: "M466.467,492h-.016a.688.688,0,0,0,0,1.375h.016a.688.688,0,0,0,0-1.375Z",
    transform: "translate(-431.03 -458.17)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, 0)",
    filter: "url(#Trac\\xE9_201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_201-2",
    "data-name": "Trac\\xE9 201",
    d: "M81.925,33.829H79.1V32.385a3.438,3.438,0,1,0-1.375,0v1.445H73.6V7.013a.688.688,0,0,0-.688-.688h-.688V4.263a.688.688,0,0,0-.688-.688h-.087A2.761,2.761,0,0,0,69.477,1.6V.688a.688.688,0,1,0-1.375,0V1.6a2.76,2.76,0,0,0-1.976,1.976h-.087a.688.688,0,0,0-.688.688V6.326h-.688a.688.688,0,0,0-.688.688V20.078H56.413a.688.688,0,0,0-.688.688V33.829h-.071a.688.688,0,0,0,0,1.375h26.27a.688.688,0,1,0,0-1.375Zm-17.948-11H62.531a.688.688,0,0,0,0,1.375h1.446v1.375H60.539a.688.688,0,0,0,0,1.375h3.438v1.375H60.539a.688.688,0,0,0,0,1.375h3.438v1.375H60.539a.688.688,0,0,0,0,1.375h3.438v1.375H57.1V21.453h6.876ZM68.79,2.888a1.375,1.375,0,0,1,1.189.687H67.6A1.375,1.375,0,0,1,68.79,2.888ZM66.727,4.95h4.126V6.326H66.727Zm5.5,28.879H65.352V7.7h6.876ZM78.416,29.7a.688.688,0,0,0-.688.688v.569a2.063,2.063,0,1,1,1.375,0v-.569A.688.688,0,0,0,78.416,29.7Z",
    transform: "translate(-48.48)",
    fill: "#50b2dc"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuridiqueIcon);
export default __webpack_public_path__ + "static/media/juridique-icon.f272517f85647d480b9e11bf22405052.svg";
export { ForwardRef as ReactComponent };